import { imageField } from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

export const quoteHeroFields = [
  {
    name: 'heading',
    type: 'string',
  },
  {
    name: 'subhead',
    type: 'string',
  },
  imageField('backgroundImage'),
  imageField('borderBottomImage'),
] as const satisfies DeepReadonly<Input[]>;

const quoteHeroConfig = {
  name: 'Quote Hero',
  inputs: quoteHeroFields,
};

export type QuoteHeroProps = GenerateBuilder<typeof quoteHeroFields>;

export default quoteHeroConfig;
